import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import {useTranslation} from "react-i18next";
import {StoreInterface} from "../store/types";

export default function MetaInfo() {
  const {t} = useTranslation(null, {keyPrefix: 'Components:MetaInfo'});

  const { franchise, company } = useSelector((state: StoreInterface) => state.initialData);

  const title: string = company?.name
    ? t('seo.title', {
        name: company?.name,
        city: company?.city,
      })
    : t('default_browser_tag');

  const description: string = t('seo.description', {
    name: company?.name,
    city: company?.city,
  });

  return (
    <div className="application">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title}</title>
        <meta name="description" content={description} />
        <link rel="icon" id="favicon" href={franchise?.logo_url} />
        <meta property="og:site_name" content={company?.name} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={franchise?.logo_url} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@FoodAmigos" />
        <meta name="twitter:creator" content="@FoodAmigos" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={franchise?.logo_url} />
      </Helmet>
    </div>
  );
}
